import React, { ReactNode } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import theme from "../../theme";

interface Props {
  text: string;
  icon: ReactNode;
  link?: string;
}

const InfoBox: React.FC<Props> = (props) => {
  const { text, icon, link } = props;

  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      onClick={
        !!link
          ? () => {
              window.location.href = link;
            }
          : undefined
      }
      display="flex"
      flexDirection="row"
      gap={3}
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: theme.palette.background.default,
        paddingY: { xs: 3, md: 7 },
        paddingX: { xs: 2, md: 7 },
        borderRadius: 2,
        fontSize: 60,
        width: "100%",
        cursor: !!link ? "pointer" : "",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{ flexShrink: 0, alignItems: "center" }}
        color={theme.palette.tertiary.main}
      >
        {icon}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          alignItems: "center",
          flexGrow: 1, // Allows this column to take available space
          flexShrink: 1, // Allows it to shrink if necessary
          minWidth: "0", // Ensures proper text wrapping
        }}
      >
        <Typography
          variant={xs ? "body1" : "h5"}
          sx={{
            wordWrap: "break-word", // Breaks long words
            overflowWrap: "break-word", // Ensures breaks happen at boundaries
            wordBreak: "break-word", // Forces word breaks if necessary
            fontWeight: link ? "bold" : "normal",
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoBox;
